import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Checkbox, Tooltip } from "@components/mantine";
import { CheckSize16Px, CrossSize16Px, MinusSize16Px } from "@coveord/plasma-react-icons";
import { Locales } from "../../strings/Locales.js";
import { PrivilegesTableUtils } from "./PrivilegesTableUtils.js";
import { usePrivilegeRow } from "./PrivilegeTableContext.js";
var getIcon = function(checked, isNoAccess) {
    if (checked) {
        return CheckSize16Px;
    }
    if (isNoAccess) {
        return MinusSize16Px;
    }
    return CrossSize16Px;
};
var getIconColor = function(checked, isNoAccess) {
    if (checked) {
        return "success";
    }
    if (isNoAccess) {
        return "info";
    }
    return "critical";
};
export var CanCreateCheckbox = function(param) {
    var id = param.id, name = param.name, owner = param.owner, targetDomain = param.targetDomain, level = param.level, systemPrivileges = param.systemPrivileges, availablePrivileges = param.availablePrivileges;
    var createPrivilegesExists = systemPrivileges.some(PrivilegesTableUtils.isCreatePrivilege);
    var ref = usePrivilegeRow(id), selectedPrivileges = ref.selectedPrivileges, onChange = ref.onChange, wholeTableInReadOnly = ref.readOnly;
    if (!createPrivilegesExists) {
        return null;
    }
    var ref1;
    var isEditAll = (ref1 = selectedPrivileges === null || selectedPrivileges === void 0 ? void 0 : selectedPrivileges.some(function(param) {
        var type = param.type, targetId = param.targetId;
        return type === "EDIT" && targetId === "*";
    })) !== null && ref1 !== void 0 ? ref1 : false;
    var isNoAccess = (selectedPrivileges !== null && selectedPrivileges !== void 0 ? selectedPrivileges : []).length === 0;
    var checked = selectedPrivileges ? selectedPrivileges.some(PrivilegesTableUtils.isCreatePrivilege) : false;
    if (PrivilegesTableUtils.isGranularPrivilegeId(id)) {
        var readOnly = wholeTableInReadOnly || isNoAccess || isEditAll;
        return /*#__PURE__*/ _jsx(Checkbox, {
            checked: checked,
            disabled: !availablePrivileges.some(PrivilegesTableUtils.isCreatePrivilege),
            readOnly: readOnly,
            onChange: function() {
                if (!readOnly) {
                    if (checked) {
                        onChange(selectedPrivileges.filter(function(privilege) {
                            return !PrivilegesTableUtils.isCreatePrivilege(privilege);
                        }));
                    } else {
                        onChange(_to_consumable_array(selectedPrivileges !== null && selectedPrivileges !== void 0 ? selectedPrivileges : []).concat([
                            {
                                type: "CREATE",
                                targetId: "*",
                                owner: owner,
                                targetDomain: targetDomain,
                                level: level
                            }
                        ]));
                    }
                }
            }
        });
    }
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: Locales.format(isEditAll ? "PrivilegesTable.canCreate.tooltip" : "PrivilegesTable.cannotCreate.tooltip", {
            name: name.toLowerCase()
        }),
        children: /*#__PURE__*/ _jsx(Box, {
            c: getIconColor(checked, isNoAccess),
            component: getIcon(checked, isNoAccess),
            height: 16
        })
    });
};

//# sourceMappingURL=CanCreateCheckbox.js.map